export default () => ({
  open:false,
  value: [],
  textValue: '',
  isValid: true,
  disabled: false,
  options: [],
  placeholder: '',
  direction: 'bottom', // default orientation
  init(){
    const selectElement = this.$el.querySelector('select')
    this.value = Array.from(selectElement.selectedOptions).map(el => el.value)
    this.textValue = Array.from(selectElement.selectedOptions).map(el => el.innerText).join(', ')
    this.$watch('value', (newValue) => {
      Array.from(selectElement.options).forEach(opt => opt.selected = newValue.includes(opt.value))
      this.textValue = newValue.map(val => this.options.find(opt => opt.value == val).text).join(', ')
    })

    this.options = Array.from(selectElement.options).map((el) => ({value: el.value, text: el.innerText, selected: el.selected}))
    this.placeholder = selectElement.getAttribute('placeholder')
    this.isValid = selectElement.checkValidity()
    this.disabled = selectElement.disabled
  },
  toggleOpen(){
    if(this.open) return this.open = false
    // calc direction and open
    const yPos = this.$refs.select.getBoundingClientRect().y
    const selectHeight = this.$refs.select.getBoundingClientRect().height
    this.direction = yPos + selectHeight > window.innerHeight ? 'top' : 'bottom'
    this.open = true
    // focus first item by default
    const firstOption = this.$el.querySelector('[role=option]')
    if(firstOption) this.$nextTick(() => firstOption.focus({ preventScroll: true }))
  },
  onHover(e){
    e.target.focus({ preventScroll: true })
  },
  onSelect(el){
    if(el.dataset.value == ''){ // placeholder/blank == empty select
      this.options.forEach(opt => opt.selected = false)
    }else{
      this.options.forEach(opt => {
        if(opt.value == el.dataset.value) opt.selected = !opt.selected
      })
    }
    this.value = this.options.filter(opt => opt.selected).map(e => e.value)

    this.$nextTick(() => {
      const selectElement = this.$root.querySelector('select')
      // 1. update validity
      this.isValid = selectElement.checkValidity()
      // 2. trigger change for listeners
      selectElement.dispatchEvent(new Event('change'))
    })
  },
  onKeyDown(e){
    if(e.key != 'Tab') e.preventDefault()
    const isOpenKey = e.key == 'ArrowUp' || e.key == 'ArrowDown'
    if (isOpenKey && !this.open) this.toggleOpen()
    if (e.key == 'Enter') this.onSelect(document.activeElement)
    if (e.key == 'ArrowUp') this.focusItem('prev')
    if (e.key == 'ArrowDown') this.focusItem('next')
  },
  focusItem(which){
    const currentItem = this.options.find((item) => item.value == document.activeElement.dataset.value)
    if(!currentItem) return
    const currentItemIndex = this.options.indexOf(currentItem)
    if(which == 'next' && currentItemIndex+1 <= this.options.length-1){
      this.$el.querySelector(`[data-value='${this.options[currentItemIndex+1].value}']`)?.focus()
    }else if(which == 'prev' && currentItemIndex-1 >= 0){
      this.$el.querySelector(`[data-value='${this.options[currentItemIndex-1].value}']`)?.focus()
    }
  },
})